import { render, staticRenderFns } from "./manalMentor.vue?vue&type=template&id=63ce2b47&"
import script from "./manalMentor.vue?vue&type=script&lang=js&"
export * from "./manalMentor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports